import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Link } from "react-router-dom";

import About from "./About"; // ✅ (correct relative path within `pages`)
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import CustomLoader from "../components/CustomLoader";
import useExternalScript from "../hooks/useExternalScript";
import useAffixNavbar from "../hooks/useAffixNavbar";
import useMagnific from "../hooks/useMagnific";
import useOwlCarousel from "../hooks/useOwlCarousel";
import useSliderInterface from "../hooks/useSliderInterface";
import { useWOW } from "../hooks/useWOW";
import ProjectsCardShow from "../components/ProjectsCardShow";
import ProjectsCarousel from "../components/ProjectsCarousel";
import usePageLoader from "../hooks/usePageLoader";
import "../assets/css/loader.css";

function Home() {
  const isLoading = usePageLoader(3000); // Show loader for at least 3 seconds

  // --- run all one-liners ---
  useAffixNavbar();
  useMagnific();
  useOwlCarousel();
  useExternalScript("/js/interface.js"); // %PUBLIC_URL% not needed in CRA
  useSliderInterface();
  useWOW(); // Initialize WOW.js for scroll animations

  return (
    <div>
      {isLoading && <CustomLoader />}

      <div className="layout" style={{ display: isLoading ? "none" : "block" }}>
        <main className="main">
          <div className="arrow-left"></div>
          <div className="arrow-right"></div>

          <div className="rev_slider_wrapper">
            <div
              id="rev_slider"
              className="rev_slider fullscreenbanner"
              data-version="5.0"
            >
              <ul>
                <li
                  data-transition="slotzoom-horizontal"
                  data-slotamount="7"
                  data-masterspeed="1000"
                  data-fsmasterspeed="1000"
                >
                  <img
                    src="img/xinchuan/main1.jpeg"
                    alt=""
                    data-bgposition="center center"
                    data-bgfit="cover"
                    data-bgrepeat="no-repeat"
                    className="rev-slidebg"
                  />

                  <div
                    className="slide-title tp-caption tp-resizeme"
                    data-x="['right','right','right','right']"
                    data-hoffset="['-18','-18','-18','-18']"
                    data-y="['middle','middle','middle','middle']"
                    data-voffset="['-35','-35', '-25']"
                    data-fontsize="['50','45', '35']"
                    data-lineheight="['80','75', '65']"
                    data-width="['1100','700','550']"
                    data-height="none"
                    data-whitespace="normal"
                    data-transform_idle="o:1;"
                    data-transform_in="x:[105%];z:0;rX:45deg;rY:0deg;rZ:90deg;sX:1;sY:1;skX:0;skY:0;s:2000;e:Power2.easeInOut;"
                    data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                    data-mask_in="x:50px;y:0px;s:inherit;e:inherit;"
                    data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                    data-start="500"
                    data-splitin="chars"
                    data-splitout="none"
                    data-responsive_offset="on"
                    data-elementdelay="0.05"
                  >
                    Elegant living room
                  </div>

                  <div
                    className="slide-subtitle tp-caption tp-resizeme"
                    data-x="['right','right','right','right']"
                    data-hoffset="['0']"
                    data-y="['middle','middle','middle','middle']"
                    data-voffset="['75','105']"
                    data-fontsize="['18']"
                    data-whitespace="nowrap"
                    data-transform_idle="o:1;"
                    data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;s:1200;e:Power1.easeInOut;"
                    data-transform_out="opacity:0;s:1000;s:1000;"
                    data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                    data-start="1500"
                    data-splitin="none"
                    data-splitout="none"
                  >
                    customization living room architecture of a new generation,
                    a building
                    <br />
                    that exists not only in the dimension of space,
                    <br />
                    but also in the dimension of time and communication.
                  </div>

                  <div
                    className="tp-caption"
                    data-x="['right','right','right','right']"
                    data-hoffset="['0','0','0','0']"
                    data-y="['middle','middle','middle','middle']"
                    data-voffset="['195','215']"
                    data-width="none"
                    data-height="none"
                    data-whitespace="nowrap"
                    data-transform_idle="o:1;"
                    data-transform_hover="o:1;rX:0;rY:0;rZ:0;z:0;s:300;e:Power1.easeInOut;"
                    data-style_hover="c:rgba(255, 255, 255, 1.00);bc:rgba(255, 255, 255, 1.00);"
                    data-transform_in="y:50px;opacity:0;s:1500;e:Power4.easeInOut;"
                    data-transform_out="y:[175%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                    data-mask_out="x:inherit;y:inherit;"
                    data-start="1500"
                    data-splitin="none"
                    data-splitout="none"
                    data-responsive_offset="on"
                  >
                    <a href="#about" className="btn js-target-scroll">
                      Look more <i className="icon-next"></i>
                    </a>
                  </div>
                </li>

                <li
                  data-transition="slotzoom-horizontal"
                  data-slotamount="7"
                  data-easein="Power3.easeInOut"
                  data-easeout="Power3.easeInOut"
                  data-masterspeed="1000"
                >
                  <img
                    src="img/xinchuan/main2.jpeg"
                    alt=""
                    data-bgposition="center center"
                    data-bgfit="cover"
                    data-bgrepeat="no-repeat"
                    className="rev-slidebg"
                  />

                  <div
                    className="slide-title tp-caption tp-resizeme"
                    data-x="['right','right','right','right']"
                    data-hoffset="['-18','-18','-18','-18']"
                    data-y="['middle','middle','middle','middle']"
                    data-voffset="['-35','-35', '-55']"
                    data-fontsize="['50','45', '35']"
                    data-lineheight="['80','75','65']"
                    data-width="['1100','700','500']"
                    data-height="none"
                    data-whitespace="normal"
                    data-transform_idle="o:1;"
                    data-transform_in="x:[105%];z:0;rX:45deg;rY:0deg;rZ:90deg;sX:1;sY:1;skX:0;skY:0;s:2000;e:Power2.easeInOut;"
                    data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                    data-mask_in="x:50px;y:0px;s:inherit;e:inherit;"
                    data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                    data-start="500"
                    data-splitin="chars"
                    data-splitout="none"
                    data-responsive_offset="on"
                    data-elementdelay="0.05"
                  >
                    energetic & refreshing kithcen
                  </div>

                  <div
                    className="slide-subtitle tp-caption tp-resizeme"
                    data-x="['right','right','right','right']"
                    data-hoffset="['0']"
                    data-y="['middle','middle','middle','middle']"
                    data-voffset="['75','105']"
                    data-fontsize="['18']"
                    data-whitespace="nowrap"
                    data-transform_idle="o:1;"
                    data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;s:1200;e:Power1.easeInOut;"
                    data-transform_out="opacity:0;s:1000;s:1000;"
                    data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                    data-start="1500"
                    data-splitin="none"
                    data-splitout="none"
                  >
                    energetic & refreshing kithcen a new generation, a building
                    <br />
                    that exists not only in the dimension of space,
                    <br />
                    but also in the dimension of time and communication.
                  </div>

                  <div
                    className="tp-caption tp-resizeme"
                    data-x="['right','right','right','right']"
                    data-hoffset="['0']"
                    data-y="['middle','middle','middle','middle']"
                    data-voffset="['195','210']"
                    data-width="none"
                    data-height="none"
                    data-whitespace="nowrap"
                    data-transform_idle="o:1;"
                    data-transform_hover="o:1;rX:0;rY:0;rZ:0;z:0;s:300;e:Power1.easeInOut;"
                    data-style_hover="c:rgba(255, 255, 255, 1.00);bc:rgba(255, 255, 255, 1.00);"
                    data-transform_in="y:50px;opacity:0;s:1500;e:Power4.easeInOut;"
                    data-transform_out="y:[175%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                    data-mask_out="x:inherit;y:inherit;"
                    data-start="1500"
                    data-splitin="none"
                    data-splitout="none"
                    data-responsive_offset="on"
                    style={{ zIndex: 8 }}
                  >
                    <a href="#about" className="btn js-target-scroll">
                      Look more <i className="icon-next"></i>
                    </a>
                  </div>
                </li>

                <li
                  data-transition="slotzoom-horizontal"
                  data-slotamount="7"
                  data-easein="Power3.easeInOut"
                  data-easeout="Power3.easeInOut"
                  data-masterspeed="1000"
                >
                  <img
                    src="img/xinchuan/main3.jpeg"
                    alt=""
                    data-bgposition="center center"
                    data-bgfit="cover"
                    data-bgrepeat="no-repeat"
                    className="rev-slidebg"
                  />

                  <div
                    className="slide-title tp-caption tp-resizeme"
                    data-x="['right','right','right','right']"
                    data-hoffset="['-18','-18','-18','-18']"
                    data-y="['middle','middle','middle','middle']"
                    data-voffset="['-35','-35', '-25']"
                    data-fontsize="['50','45', '35']"
                    data-lineheight="['80','75', '65']"
                    data-width="['1000','700','550']"
                    data-height="none"
                    data-whitespace="normal"
                    data-transform_idle="o:1;"
                    data-transform_in="x:[105%];z:0;rX:45deg;rY:0deg;rZ:90deg;sX:1;sY:1;skX:0;skY:0;s:2000;e:Power2.easeInOut;"
                    data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                    data-mask_in="x:50px;y:0px;s:inherit;e:inherit;"
                    data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                    data-start="500"
                    data-splitin="chars"
                    data-splitout="none"
                    data-responsive_offset="on"
                    data-elementdelay="0.05"
                  >
                    Modern Living Room in london
                  </div>

                  <div
                    className="slide-subtitle tp-caption tp-resizeme"
                    data-x="['right','right','right','right']"
                    data-hoffset="['0']"
                    data-y="['middle','middle','middle','middle']"
                    data-voffset="['75','105']"
                    data-fontsize="['18']"
                    data-whitespace="nowrap"
                    data-transform_idle="o:1;"
                    data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;s:1200;e:Power1.easeInOut;"
                    data-transform_out="opacity:0;s:1000;s:1000;"
                    data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                    data-start="1500"
                    data-splitin="none"
                    data-splitout="none"
                  >
                    Modern Living Room in london a new generation,
                    <br />
                    a building that exists not only in the dimension of space,
                    <br />
                    but also in the dimension of time and communication.
                  </div>

                  <div
                    className="tp-caption tp-resizeme"
                    data-x="['right','right','right','right']"
                    data-hoffset="['0','0','0','0']"
                    data-y="['middle','middle','middle','middle']"
                    data-voffset="['195','215']"
                    data-width="none"
                    data-height="none"
                    data-whitespace="nowrap"
                    data-transform_idle="o:1;"
                    data-transform_hover="o:1;rX:0;rY:0;rZ:0;z:0;s:300;e:Power1.easeInOut;"
                    data-style_hover="c:rgba(255, 255, 255, 1.00);bc:rgba(255, 255, 255, 1.00);"
                    data-transform_in="y:50px;opacity:0;s:1500;e:Power4.easeInOut;"
                    data-transform_out="y:[175%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                    data-mask_out="x:inherit;y:inherit;"
                    data-start="1500"
                    data-splitin="none"
                    data-splitout="none"
                    data-responsive_offset="on"
                    style={{ zIndex: 8 }}
                  >
                    <a href="#about" className="btn js-target-scroll">
                      Look more <i className="icon-next"></i>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </main>

        <div className="content">
          <section id="about" className="about section">
            <div className="container">
              <header className="section-header">
                <h2 className="section-title">
                  About <span className="text-primary">us</span>
                </h2>
                <strong className="fade-title-left">About</strong>
              </header>
              <div className="section-content">
                <div className="row-base row">
                  <div className="col-base col-sm-6 col-md-4">
                    <h3 className="col-about-title">
                      Introduction<span className="text-primary">.</span>
                    </h3>
                    <div className="col-about-info">
                      <p>
                        Established in Johor Bahru registered with the SSM as
                        well as holding approval certificate of CIDB. Founded in
                        January 2018 and until now, the company has an
                        experience in various fields of building works, civil
                        works, design and furniture work.
                      </p>
                    </div>
                  </div>
                  <div className="col-base col-about-spec col-sm-6 col-md-4">
                    <h3 className="col-about-title">
                      our
                      <br />
                      specialization<span className="text-primary">:</span>
                    </h3>
                    <div className="service-item">
                      <img
                        alt=""
                        width="46"
                        src="img/img-icon/icon-architecture.png"
                      />
                      <h4>Designing</h4>
                    </div>
                    <div className="service-item">
                      <img
                        alt=""
                        width="58"
                        src="img/img-icon/icon-interiors.png"
                      />
                      <h4>Carpentry</h4>
                    </div>
                    <div className="service-item">
                      <img
                        alt=""
                        width="58"
                        src="img/img-icon/icon-planing.png"
                      />
                      <h4>Renovation</h4>
                    </div>
                  </div>
                  <div className="clearfix visible-sm"></div>
                  <div className="col-base col-about-img col-sm-6 col-md-4">
                    <img
                      alt=""
                      className="img-responsive"
                      src="img/xinchuan/xinchuan_office2.jpg"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="projects section">
            <div className="container">
              <h2 className="section-title">
                Our <span className="text-primary">projects</span>
              </h2>
            </div>
            <div className="section-content">
              <ProjectsCardShow />
            </div>
          </section>

          <section className="experience section">
            <div className="container">
              <div
                className="text-parallax"
                data-stellar-background-ratio="1.00"
                style={{ backgroundImage: "url('/img/bg/text-1.jpg')" }}
              >
                <div className="text-parallax-content">20</div>
              </div>
              <h4 className="experience-info wow fadeInRight">
                <span className="text-primary">Years of successful work</span>
                <br />
                in the market
              </h4>
            </div>
          </section>

          <section className="clients section">
            <div className="container">
              <header className="section-header">
                <h2 className="section-title">
                  Our <span className="text-primary">clients</span>
                </h2>
                <strong className="fade-title-left">clients</strong>
              </header>
              <div className="section-content">
                <ul className="clients-list">
                  <li className="client">
                    <a href="#">
                      <img alt="" src="img/clients/1.png" />
                    </a>
                  </li>
                  <li className="client">
                    <a href="#">
                      <img alt="" src="img/clients/2.png" />
                    </a>
                  </li>
                  <li className="client">
                    <a href="#">
                      <img alt="" src="img/clients/3.png" />
                    </a>
                  </li>
                  <li className="client">
                    <a href="#">
                      <img alt="" src="img/clients/4.png" />
                    </a>
                  </li>
                  <li className="client">
                    <a href="#">
                      <img alt="" src="img/clients/5.png" />
                    </a>
                  </li>
                  <li className="client">
                    <a href="#">
                      <img alt="" src="img/clients/1.png" />
                    </a>
                  </li>
                  <li className="client">
                    <a href="#">
                      <img alt="" src="img/clients/2.png" />
                    </a>
                  </li>
                  <li className="client">
                    <a href="#">
                      <img alt="" src="img/clients/3.png" />
                    </a>
                  </li>
                  <li className="client">
                    <a href="#">
                      <img alt="" src="img/clients/4.png" />
                    </a>
                  </li>
                  <li className="client">
                    <a href="#">
                      <img alt="" src="img/clients/5.png" />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="section-content">
                <Link to="/contacts" className="btn btn-shadow-2">
                  Work together <i className="icon-next"></i>
                </Link>
                {/*<a href="/contacts" className="btn btn-shadow-2">
                  Work together <i className="icon-next"></i>
                </a>*/}
              </div>
            </div>
          </section>

          <ContactSection />
          <Footer />

          <div className="page-lines">
            <div className="container">
              <div className="col-line col-xs-4">
                <div className="line"></div>
              </div>
              <div className="col-line col-xs-4">
                <div className="line"></div>
              </div>
              <div className="col-line col-xs-4">
                <div className="line"></div>
                <div className="line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
